import { Icon, Checkbox, VerticalMenu, Tooltip } from "@scuf/common";
import "./css/deviceDetail.scss";
import {
  getISOList,
  getListSnapshot,
  getUnMountISO,
  getWMKSDetails,
  removeSelectedVM,
  setLoading,
  setSelectedVM,
  setSelectedVMWare,
} from "../../../store/action";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { AppState } from "../../../../common/store/combinedReducer";
import _ from "lodash";
import GreenDot from "../../../../common/assets/DotsGreen.png";
import RedDot from "../../../../common/assets/StatusRed.png";
import suspendedVM from "../../../../common/assets/suspendedVM.png";
import { customToast } from "../../../../App";
import { REQUIRED_PERMISSIONS } from "../../../../common/authentication/config";
import { useNavigate } from "react-router-dom";
import {
  formatDate,
  sortDataByKey,
} from "../../../../common/utility/plantDetailUtils";
const DeviceDetails = (props: any) => {
  const dispatch = useDispatch();
  const powerOn = GreenDot;
  const navigate = useNavigate();
  const selectedVM = useSelector((state: AppState) => {
    return state.reducer.selectedVM;
  });
  const selectedVMWare = useSelector((state: AppState) => {
    return state.reducer.selectedVMWare;
  });
  const wmksDetails = useSelector((state: AppState) => {
    return state.reducer.wmksDetails;
  });
  const wmksStatus = useSelector((state: AppState) => {
    return state.reducer.wmksStatus;
  });
  const selectedTenant: any = useSelector((state: AppState) => {
    return state.reducer.selectedTenant;
  });
  // const [clicked, setClicked] = useState(false);
  const [selectedVMData, setSelectedVMData] = useState<any>([]);
  const vmDetails = props?.vmDetails;
  const [dom, setDom] = useState(false);
  const [selectedId, setId] = useState("");
  const [selectedName, setName] = useState("");
  const [openVmTab, setVmTab] = useState(false);
  const [openMenuId, setOpenMenuId] = useState<string | null>(null);
  let openedTabs: any;
  useEffect(() => {
    if (props.clearAll === true) {
      vmDetails?.forEach((element: any) => {
        element.checked = false;
      });
      setSelectedVMData([]);
      props.setClearAll(false);
    }
    if (selectedVM?.length > 0) {
      if (_.some(vmDetails, ["checked", true]) === true) {
        // if (_.every(selectedVMData, ["snapshot", true]) === true) {
        //   props.setRestoreSnapshotDisable(false);
        // } else if (_.every(selectedVMData, ["snapshot", true]) === false) {
        //   props.setRestoreSnapshotDisable(true);
        // }
        if (_.every(selectedVMData, ["status", "POWERED_ON"]) === true) {
          props.setRestart(false);
          // props.setShutDown(false);
          props.setCreateSnapshotDisable(false);
        } else if (
          _.every(selectedVMData, ["status", "POWERED_OFF"]) === true
        ) {
          props.setRestart(true);
          // props.setShutDown(true);
          props.setCreateSnapshotDisable(false);
        } else if (
          _.every(selectedVMData, ["status", "POWERED_ON"]) === false
        ) {
          props.setRestart(true);
          // props.setShutDown(true);
          props.setCreateSnapshotDisable(false);
        }

        if (_.some(selectedVMData, ["isWindows", false])) {
          props.setShutDown(true); // shutdown is disabled for linux vm
        } else if (_.every(selectedVMData, ["isWindows", true])) {
          if (_.every(selectedVMData, ["status", "POWERED_ON"])) {
            props.setShutDown(false);
          } else {
            props.setShutDown(true);
          }
        }
      }
    } else {
      // props.setRestoreSnapshotDisable(true);
      props.setRestart(true);
      props.setShutDown(true);
      props.setCreateSnapshotDisable(true);
    }
  }, [vmDetails, selectedVMData, props.clearAll]);

  function getVM(
    id: string,
    name: string,
    status: string,
    isVmWindow: boolean
  ) {
    // Track opened tabs
    openedTabs = Number(localStorage.getItem("openedTabs") || "0");
    const checkPermission = REQUIRED_PERMISSIONS.ACCESS_AND_WORK_ON_VM.every(
      (p: string) => props.orgData?.permissions?.includes(p)
    );
    if (openedTabs >= 10) {
      customToast(
        "You can open a maximum of 10 nodes at a time. Please close one to open another.",
        "critical"
      );
    } else if (
      checkPermission &&
      props.orgData?.name &&
      (status === "POWERED_ON" || status === "Creating Snapshot...") &&
      !openVmTab
    ) {
      setId(id);
      setName(name);
      dispatch(setSelectedVMWare({ name, id, isVmWindow }));

      if (isVmWindow) {
        props.setClicked(true);
      } else {
        props.setOpenVm(true);
        setVmTab(true);
      }
    }
  }

  useEffect(() => {
    if (props.openVm) {
      // props.setOpenVm(false);
      // dispatch(setSelectedVMWare({ name: selectedName, id: selectedId }));
      dispatch(
        getWMKSDetails({ 
          id: selectedId,
          accessToken: localStorage.getItem("access_token"),
          siteId: props.orgData?.siteId,
          orgName: props.orgData?.name,
          tenantId: selectedTenant,
          orgId: selectedTenant,
        })
      );
      setVmTab(true);
    }
  }, [props.openVm]);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      // Close the VerticalMenu if click is outside the menu or option icon
      const menu = document.getElementById("vm-menu");
      const optionIcons = document.querySelectorAll(
        '[data-testid="option-icon"]'
      );
      const isClickOnOptionIcon = Array.from(optionIcons).some((icon) =>
        icon.contains(event.target as Node)
      );
      if (
        menu &&
        !menu.contains(event.target as Node) &&
        !isClickOnOptionIcon
      ) {
        setOpenMenuId(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);

    const handleStorage = (event: StorageEvent) => {
      if (event.key === "vmTabMounted") {
        setVmTab(false);
      }
    };
    window.addEventListener("storage", handleStorage);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);
  // const formatDate = (date: any) => {
  //   const options: any = {
  //     day: "2-digit",
  //     month: "short",
  //     year: "numeric",
  //     hour: "2-digit",
  //     minute: "2-digit",
  //     second: "2-digit",
  //   };
  //   const formatted = new Date(date).toLocaleDateString("en-US", options);
  //   const dateParts = formatted
  //     .substring(0, formatted.indexOf(","))
  //     .split(" ")
  //     .reverse()
  //     .join(" ");
  //   // Return the formatted date with uppercase month abbreviation and desired format
  //   const formattedDate =
  //     dateParts + formatted.substr(formatted.indexOf(",") + 1);
  //   return formattedDate;
  // };
  useEffect(() => {
    if (
      wmksDetails?.host !== null &&
      wmksDetails?.host !== undefined &&
      props.openVm &&
      wmksStatus === 200
    ) {
      window
        .open(
          `/dashboard/vmware` +
            `/${props.orgData?.siteId}/${selectedVMWare.name}`,
          "",
          "noopener"
        )
        ?.focus();
      localStorage.setItem(
        selectedVMWare.name,
        JSON.stringify({
          name: selectedVMWare.name,
          id: selectedId,
          siteId: props.orgData?.siteId,
          orgId: props.orgId,
          orgName: props.orgData?.name,
          wmksData: wmksDetails,
          isVmWindow: selectedVMWare.isVmWindow,
          tenantId: selectedTenant,
        })
      );
      // openedTabs = Number(localStorage.getItem("openedTabs") || "0");
      // openedTabs += 1;
      // localStorage.setItem("openedTabs", openedTabs?.toString());
      // setVmTab(false);
      props.setOpenVm(false);
      props.setClicked(false);
    } else if (props.openVm) {
      if (wmksStatus === 409) customToast(wmksDetails?.message, "critical");
      // else if (
      //   wmksStatus === 409 &&
      //   wmksDetails &&
      //   wmksDetails.minorErrorCode === "INVALID_STATE"
      // )
      //   customToast(
      //     `You cannot view the console since VM ${selectedVMWare.name} is not powered on. To view the console first refresh and power on the virtual machine`,
      //     "critical"
      //   );
      else if (wmksStatus === 500)
        customToast(
          "Error in connection. Please try after sometime",
          "critical"
        );
      else if (wmksStatus === 401 || wmksStatus === 403)
        customToast("Unauthorized to access the vm.", "critical");
      setVmTab(false);
      props.setOpenVm(false);
      props.setClicked(false);
    }
  }, [wmksDetails, wmksStatus]);

  const validateCheckBox = (checkData: any) => {
    let checked: boolean = false;
    vmDetails?.forEach((element: any) => {
      if (element.id === checkData.id) {
        checked =
          element.checked !== undefined
            ? element.checked
            : checkData.checked !== undefined
            ? checkData.checked
            : false;
      }
    });
    return checked;
  };
  const handleCheckbox = (checked: boolean, data: any) => {
    vmDetails?.forEach((vm: any) => {
      if (vm.id === data.id) {
        if (checked) {
          vm.checked = true;
          data.checked = true;
          selectedVMData.push(vm);
          const val = _.uniq(selectedVMData);
          setSelectedVMData(val);
          dispatch(setSelectedVM(vm));
          setOpenMenuId(null);
        } else if (!checked) {
          vm.checked = false;
          data.checked = false;
          const newSelected: any = selectedVMData?.filter(
            (cur: any) => cur.id !== data.id
          );
          setSelectedVMData(newSelected);
          dispatch(removeSelectedVM(vm));
          setOpenMenuId(null);
        }
      }
    });
    setDom(!dom);
  };

  const handlePower = (checked: boolean, data: any) => {
    if (props.orgData && props.orgData.IsVCDAlive === false) {
      customToast(
        "This site is not available currently, please try after sometime.",
        "critical"
      );
      props.handleClearAll();
    } else {
      vmDetails?.forEach((vm: any) => {
        if (vm.id === data.id) {
          if (checked) {
            vm.isOn = true;
            data.isOn = true;
            vm.isIntermediate = true;
            data.isIntermediate = true;
            props.setCloseConfirmModal(true);
            props.setHeader("Power On");
            props.setContent("power on");
            props.setPoweredVm(data);
          } else if (!checked) {
            vm.isOn = false;
            data.isOn = false;
            vm.isIntermediate = true;
            data.isIntermediate = true;
            props.setCloseConfirmModal(true);
            props.setHeader("Power Off");
            props.setContent("power off");
            props.setPoweredVm(data);
          }
        }
      });
    }
    setDom(!dom);
  };

  return (
    <div className="detail-wrapper">
      {vmDetails?.length > 0 && (
        <>
          {/* {props.orgData?.isTwin && (
            <div
              className="plant-detail-wrapper-compare"
              onClick={() => goToCompare()}
            >
              <div className="card-container-compare">
                <span className="deviation-percentage">
                  {props.orgData?.percentageSimilarity}%
                </span>
                <span className="deviation-text">
                  Similar to the Live System
                </span>
                <span className="deviation-last-fetched">
                  Last Data Fetched on
                </span>
                <span className="deviation-last-fetched-val">
                  {props.orgData?.lastUpdated
                    ? formatDate(props.orgData?.lastUpdated)
                    : "-- --"}
                </span>
                <button className="deviation-button">See Deviation</button>
              </div>
            </div>
          )} */}
          {vmDetails?.map((data: any) => {
            return (
              <div
                className={
                  data.status == "POWERED_ON" || data.status == "POWERED_OFF"
                    ? "plant-detail-wrapper"
                    : "plant-detail-wrapper-inprogress"
                }
                key={"detail-wrapper" + data.id}
              >
                <div className="card-header">
                  <div className="org-container">
                    <Icon
                      root="global"
                      name={"pc"}
                      size="medium"
                      color={
                        data.status === "POWERED_ON" ||
                        data.status === "Creating Snapshot..."
                          ? "white"
                          : "gray"
                      }
                    />
                    <label
                      className={
                        REQUIRED_PERMISSIONS.ACCESS_AND_WORK_ON_VM.every(
                          (p: string) => props.orgData?.permissions?.includes(p)
                        ) &&
                        (data.status === "POWERED_ON" ||
                          (data.status === "POWERED_ON" &&
                            data.intermediateStatus ===
                              "Creating Snapshot...")) &&
                        !openVmTab
                          ? "org-icon-label"
                          : data.status !== "POWERED_ON" &&
                            data.status !== "POWERED_OFF"
                          ? "org-icon-label-inprogress"
                          : "org-icon-label-noPermission"
                      }
                      onClick={() =>
                        getVM(data.id, data.name, data.status, data.isWindows)
                      }
                    >
                      {data.name}
                    </label>
                  </div>
                  {REQUIRED_PERMISSIONS.SELF_SERVICE_INDIVIDUAL_VMS.every(
                    (p: string) => props.orgData?.permissions?.includes(p)
                  ) &&
                  (data.status === "POWERED_ON" ||
                    data.status === "POWERED_OFF") ? (
                    <Checkbox
                      className="checkbox-dashboard"
                      checked={validateCheckBox(data)}
                      onChange={(checked: any) => handleCheckbox(checked, data)}
                      id={data.id}
                      data-testid={data.id}
                      // disabled={!data.isSelfServiceEnabled}
                    />
                  ) : null}
                  {(data.status === "POWERED_ON" ||
                    data.status === "POWERED_OFF") &&
                  data.isWindows ? ( // &&
                    // REQUIRED_PERMISSIONS.SELF_SERVICE_INDIVIDUAL_VMS.every(
                    //   (p: string) => props.orgData?.permissions?.includes(p))
                    <Icon
                      root="common"
                      name={"ellipsis-vertical"}
                      size="medium"
                      color={"white"}
                      className="option-icon"
                      data-testid="option-icon"
                      onClick={() => {
                        setOpenMenuId((prevId) =>
                          prevId === data.id ? null : data.id
                        );
                        props.handleClearAll();
                      }}
                    />
                  ) : null}
                  {openMenuId === data.id && (
                    <VerticalMenu
                      data-testid="vm-menu"
                      id="vm-menu"
                      pointing={true}
                    >
                      {REQUIRED_PERMISSIONS.CAN_VIEW_ISO.every((p: string) =>
                        props.orgData?.permissions?.includes(p)
                      ) &&
                        REQUIRED_PERMISSIONS.CAN_MOUNT_ISO.every((p: string) =>
                          props.orgData?.permissions?.includes(p)
                        ) && (
                          <VerticalMenu.Item
                            className="vm-menu-item"
                            id="vm-menu-item"
                            // disabled={data.isoStatus.isISOPresent}
                            onClick={() => {
                              dispatch(removeSelectedVM()); // remove all selected vm
                              setOpenMenuId(null);
                              dispatch(setLoading(true));
                              dispatch(setSelectedVM(data)); // set only 1 selected vm
                              dispatch(
                                getISOList({
                                  // orgId: props.orgId,
                                  tenantId: selectedTenant,
                                  accessToken:
                                    localStorage.getItem("access_token"),
                                  siteId: props.orgData?.siteId,
                                  pageNumber: 1,
                                })
                              );
                            }}
                          >
                            Insert Media
                          </VerticalMenu.Item>
                        )}
                      {REQUIRED_PERMISSIONS.CAN_UNMOUNT_ISO.every((p: string) =>
                        props.orgData?.permissions?.includes(p)
                      ) && (
                        <VerticalMenu.Item
                          className="vm-menu-item"
                          id="vm-menu-item"
                          // disabled={!data.isoStatus.isISOPresent}
                          onClick={() => {
                            dispatch(removeSelectedVM()); // remove all selected vm
                            props.setHeader("Eject Media");
                            props.setCloseConfirmModal(true);
                            setOpenMenuId(null);
                            dispatch(setSelectedVM(data)); // set only 1 selected vm
                          }}
                        >
                          Eject Media
                        </VerticalMenu.Item>
                      )}
                      {REQUIRED_PERMISSIONS.SELF_SERVICE_INDIVIDUAL_VMS.every(
                        (p: string) => props.orgData?.permissions?.includes(p)
                      ) && (
                        <VerticalMenu.Item
                          className="vm-menu-item"
                          id="vm-menu-item"
                          // disabled={!data.isoStatus.isISOPresent}
                          onClick={() => {
                            if (
                              props.orgData &&
                              props.orgData.IsVCDAlive === false
                            ) {
                              customToast(
                                "This site is not available currently, please try after sometime.",
                                "critical"
                              );
                            } else {
                              dispatch(removeSelectedVM()); // remove all selected vm
                              dispatch(setLoading(true));
                              props.setHeader("Create Snapshot");
                              props.setContent("create snapshot for");
                              dispatch(
                                getListSnapshot({
                                  orgId: props.orgId,
                                  accessToken:
                                    localStorage.getItem("access_token"),
                                  siteId: props.orgData?.siteId,
                                  vmId: data.id,
                                })
                              );
                              // props.setSnapShotShow(true);
                              setOpenMenuId(null);
                              dispatch(setSelectedVM(data)); // set only 1 selected vm
                            }
                          }}
                        >
                          Create Snapshot
                        </VerticalMenu.Item>
                      )}
                      {REQUIRED_PERMISSIONS.SELF_SERVICE_INDIVIDUAL_VMS.every(
                        (p: string) => props.orgData?.permissions?.includes(p)
                      ) && (
                        <VerticalMenu.Item
                          className="vm-menu-item"
                          id="vm-menu-item"
                          disabled={data.snapshot === false}
                          onClick={() => {
                            if (
                              props.orgData &&
                              props.orgData.IsVCDAlive === false
                            ) {
                              customToast(
                                "This site is not available currently, please try after sometime.",
                                "critical"
                              );
                            } else {
                              dispatch(removeSelectedVM()); // remove all selected vm
                              dispatch(setLoading(true));
                              props.setHeader("Restore Snapshot");
                              props.setContent("restore snapshot for");
                              dispatch(
                                getListSnapshot({
                                  orgId: props.orgId,
                                  accessToken:
                                    localStorage.getItem("access_token"),
                                  siteId: props.orgData?.siteId,
                                  vmId: data.id,
                                })
                              );
                              // props.setSnapShotShow(true);
                              setOpenMenuId(null);
                              dispatch(setSelectedVM(data)); // set only 1 selected vm
                            }
                          }}
                        >
                          Restore Snapshot
                        </VerticalMenu.Item>
                      )}
                      {REQUIRED_PERMISSIONS.SELF_SERVICE_INDIVIDUAL_VMS.every(
                        (p: string) => props.orgData?.permissions?.includes(p)
                      ) && (
                        <VerticalMenu.Item
                          className="vm-menu-item"
                          id="vm-menu-item"
                          disabled={data.snapshot === false}
                          onClick={() => {
                            if (
                              props.orgData &&
                              props.orgData.IsVCDAlive === false
                            ) {
                              customToast(
                                "This site is not available currently, please try after sometime.",
                                "critical"
                              );
                            } else {
                              dispatch(removeSelectedVM()); // remove all selected vm
                              dispatch(setLoading(true));
                              props.setHeader("Delete Snapshot");
                              props.setContent("delete snapshot for");
                              dispatch(
                                getListSnapshot({
                                  orgId: props.orgId,
                                  accessToken:
                                    localStorage.getItem("access_token"),
                                  siteId: props.orgData?.siteId,
                                  vmId: data.id,
                                })
                              );
                              // props.setSnapShotShow(true);
                              setOpenMenuId(null);
                              dispatch(setSelectedVM(data)); // set only 1 selected vm
                            }
                          }}
                        >
                          Delete Snapshot
                        </VerticalMenu.Item>
                      )}
                    </VerticalMenu>
                  )}
                </div>
                {data.intermediateStatus !== null ? (
                  // {data.status !== "POWERED_ON" &&
                  // data.status !== "POWERED_OFF" &&
                  // data.status !== "SUSPENDED" ? (
                  <div className="overlay-inprogress">
                    <span className="text-inprogress">
                      {data.intermediateStatus}
                    </span>
                  </div>
                ) : (
                  <div className="card-container">
                    <div className="vm-card-status">
                      <div className="span-container" id="node-state">
                        <span className="card-data-value">
                          Node State &nbsp;
                          {REQUIRED_PERMISSIONS.SELF_SERVICE_INDIVIDUAL_VMS.every(
                            (p: string) =>
                              props.orgData?.permissions?.includes(p)
                          ) &&
                          (data.status === "POWERED_ON" ||
                            data.status === "POWERED_OFF" ||
                            data.status === "SUSPENDED") ? (
                            <Checkbox
                              className={
                                data.isIntermediate
                                  ? "intermediate powerToggle"
                                  : "powerToggle"
                              }
                              toggle={true}
                              id={"powerToggle" + data.id}
                              data-testid={"powerToggle" + data.id}
                              checked={data.isOn}
                              indeterminate={data.isIntermediate}
                              disabled={data.isIntermediate}
                              onChange={(checked: boolean) => {
                                handlePower(checked, data);
                                setOpenMenuId(null);
                              }}
                            />
                          ) : null}
                          <span className="card-data-val">
                            {data.status}
                            {data.status === "SUSPENDED" && (
                              <Tooltip
                                className="suspended-tooltip"
                                element={
                                  <img
                                    src={suspendedVM}
                                    className="suspended-icon"
                                    data-testid="suspended-option-icon"
                                    alt="Suspended VM"
                                  />
                                }
                                content="Power ON to enable the suspended VM."
                                hideOnScroll={true}
                                event="hover"
                                position="top center"
                                id="suspended-tooltip"
                              />
                            )}
                          </span>
                        </span>
                      </div>
                    </div>
                    <div
                      className="card-device-version"
                      key={"card-device-version" + data.id}
                    >
                      {data &&
                        data.vmMetadata &&
                        sortDataByKey(data.vmMetadata).find((details: any) => {
                          return details.key === "Node Type";
                        }) && (
                          <span className="card-data-value" key={"Node Type"}>
                            Node Type:{" "}
                            <span className="card-data-val version">
                              {
                                sortDataByKey(data.vmMetadata).find(
                                  (details: any) => details.key === "Node Type"
                                )?.value
                              }
                            </span>
                          </span>
                        )}
                      {data &&
                        data.vmMetadata &&
                        sortDataByKey(data.vmMetadata).map((details: any) => {
                          if (
                            details.key !== "Node Type" &&
                            (details.key === "Version" ||
                              details.key === "Server Patch" ||
                              (details.key === "FTE Device Index" &&
                                !data.isWindows))
                          ) {
                            return (
                              <span
                                className="card-data-value"
                                key={details.key}
                              >
                                {details.key}:{" "}
                                <span className="card-data-val version">
                                  {details.value}
                                </span>
                              </span>
                            );
                          }
                        })}
                      {data.isWindows && (
                        <>
                          <span className="card-data-value card-date">
                            Last Snapshot Restored:&nbsp;
                            <span className="card-data-val">
                              {data.snapshotRestored?.snapshotName ? (
                                <Tooltip
                                  element={
                                    <span className="value-snapshot-name">
                                      {data.snapshotRestored.snapshotName
                                        .length > 12
                                        ? data.snapshotRestored.snapshotName.slice(
                                            0,
                                            12
                                          ) + "..."
                                        : data.snapshotRestored.snapshotName}
                                    </span>
                                  }
                                  content={data.snapshotRestored.snapshotName}
                                  className="tooltip-snapname"
                                  id="tooltip-snapname"
                                  position="top center"
                                  event="hover"
                                />
                              ) : (
                                "-- --"
                              )}
                            </span>
                          </span>
                          <span className="card-data-value card-date">
                            Last Restored On:{" "}
                            <span className="card-data-val">
                              {data.snapshotRestored?.dateRestored
                                ? formatDate(
                                    data.snapshotRestored?.dateRestored
                                  )
                                : "-- --"}
                            </span>
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};
export default DeviceDetails;
